import React from "react"
import { Col, Row } from "reactstrap"
import PropTypes from "prop-types"
import { SaveButton } from "components/Buttons"

const EventBulkDeleteModal = ({
  numberOfEvents,
  handleHideEventBulkDeleteModal,
  handleDeleteBulkAction,
  loading,
}) => {
  return (
    <React.Fragment>
      <Row>
        <h5>Are you sure you want to delete {numberOfEvents} experience(s)?</h5>
      </Row>
      <Row>
        <p>
          If you've selected an experience which belongs to multiple categories,
          the experience will be globally deleted (from all categories).
        </p>
      </Row>
      <Row>
        <Col>
          <SaveButton
            type="button"
            fullWidth={true}
            color="danger"
            content="Cancel"
            onClick={handleHideEventBulkDeleteModal}
          />
        </Col>
        <Col>
          <SaveButton
            content="Delete"
            fullWidth={true}
            onClick={handleDeleteBulkAction}
            loading={loading}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

EventBulkDeleteModal.propTypes = {
  handleHidePublishModal: PropTypes.func,
  handlePublishEvents: PropTypes.func,
  numberOfEvents: PropTypes.number,
  loading: PropTypes.bool,
}

export default EventBulkDeleteModal
